export const environment = {
  production: false,
  defaultauth: 'localhost',
  backend: 'https://api.nikki-staging.nl/api/',
  backend_web: 'https://api.nikki-staging.nl/',
  env: 'staging',
  name: 'NIKKI',
  locale: "en",
  pusher: {
    key: "b7f1a102f794f3cdadc1"
  },
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    databaseURL: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "" 
  },
  sentry: {
    dsn: 'https://df77b24025b78154bb62674f86f17f09@o4507735602298880.ingest.de.sentry.io/4508595398443088',
    environment: 'staging'
  }
};